import script from "./cpt-switch-option.vue?vue&type=script&setup=true&lang=js"
export * from "./cpt-switch-option.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__